import*as e from"react";function r(r){const t=e.useRef(r);return e.useEffect((()=>{t.current=r})),e.useMemo((()=>(...e)=>t.current?.(...e)),[])}export{r as useCallbackRef};
//# sourceMappingURL=index.js.map
